import { EmailTemplate } from "types/emailTemplateTypes";

export const parseEmailTemplateResponse = (data: any): EmailTemplate => ({
    id: Number(data.id),
    name: data.name,
    description: data.description,
    styleFrameColor: data.styleFrameColor,
    styleButtonColor: data.styleButtonColor,
    styleButtonTextColor: data.styleButtonTextColor,
    content: data.content,
})